const getInitials = (input: string): string => {
  const first = input.split(' ').shift()?.[0] || '';
  const last = input.split(' ').length > 1 ? input.split(' ').pop()?.[0] || '' : '';
  return `${first}${last}`.toUpperCase();
};
export default getInitials;
